import { getDealerSiteRoutes } from './common'

export default getDealerSiteRoutes('/dsite/:domain/')
